import isArray from 'lodash/isArray';
import { LegacyApiPlan, LegacyReduxPlan } from 'types/legacyDashboard';

const getZones = (plan: LegacyApiPlan) => {
  if (!plan.zones || isArray(plan.zones)) {
    return Object.keys(plan)
      .filter((key) => key.includes('amount'))
      .map((key) => key.replace(/amount/, ''));
  }
  return Object.keys(plan.zones);
};

const convertApiPlanToReduxPlan = (plans: Array<LegacyApiPlan>) => {
  const reduxPlans: Array<LegacyReduxPlan> = new Array(plans.length);

  plans.forEach((plan, i) => {
    reduxPlans[i] = {
      ...structuredClone(plan),
      zones: getZones(plan),
      zoneDetails: structuredClone(plan.zones),
    };
  });

  return reduxPlans;
};

export default convertApiPlanToReduxPlan;
